import type { SVGProps } from 'react'

export const TrendsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.4167 0.75L10.3333 7.83333L6.16667 3.66667L0.75 9.08333M17.4167 5.75V0.75H12.4167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
